//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import DeletePopup from "../Common/Popup/DeletePopup";
import AddPushNotifications from "./AddPushNotifications";
import { notificationActions } from "../../_actions";

class PushNotifications extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getNotificationsList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            notifications: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the notifications data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.notification_type =  "push";

        dispatch(notificationActions.getNotificationsList(apiConstants.GET_NOTICATIONS, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        if (props.getNotificationsList) {
            if (props.getNotificationsList.getNotificationsList) {
                if (props.getNotificationsList.getNotificationsList.data.data) {
                    this.setState({
                        totalPage: props.getNotificationsList.getNotificationsList.data.data.totalPages,
                        totalDataCount: props.getNotificationsList.getNotificationsList.data.data.totalCount,
                        getNotificationsList: props.getNotificationsList.getNotificationsList.data.data,
                    })
                }
            }
        }
    }

    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.notification_type =  "push";

        dispatch(notificationActions.getNotificationsList(apiConstants.GET_NOTICATIONS, postData));
    }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (notifications, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddPushNotification' })
        }
        this.setState({ notifications, [type]: true })
    };

    EditPopupOpen = (notificationData, type) => {
        this.setState({
            data: notificationData,
            popupType: 'EditPushNotification',
            addButton: true
        });

        this.setState({ [type]: true })
    }


    DeletePopupOpen = (notificationId, type) => {
        this.setState({
            deleteId: notificationId
        });

        this.setState({ [type]: true })
    }
    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            notifications: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    /*
        we can remove the selected data, using the below function
    */
    deleteNotifications = (notificationId) => {
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.notification_type = "push";

        let obj = {};
        obj.id = notificationId;
        this.props.dispatch(notificationActions.deleteNotifications(apiConstants.DELETE_NOTIFICATIONS, obj, apiConstants.GET_NOTICATIONS, postData));
        this.popupClose('deleteOpen');
    }

    /*
    *   pushNotifications
    */
    pushNotifications = (title, body) => {
        let obj = {
          title : title,
          body : body
        };
        this.props.dispatch(notificationActions.sentPushNotifications(apiConstants.SENT_PUSH_NOTIFICATIONS, obj));
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        return (
            <div id="wrapper">
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_PUSH_NOTIFICATIONS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_PUSH_NOTIFICATIONS}</h1>
                                <a href="javascript:void(0)" onClick={() => this.popupOpen(this.state.notifications, 'editOpen', 'addButton')}>
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>
                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    {/* style={{"overflowY": "scroll"}} */}
                                    <div className="table-responsive" >
                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="col" width="20%">{siteConstants.GEN_TITLE}</th>
                                                    <th scope="col">{siteConstants.GEN_MESSAGE}</th>
                                                    <th scope="col" width="18%">{siteConstants.GEN_MESSAGE_FOR}</th>
                                                    <th width="5%">{siteConstants.PUSH}</th>
                                                    <th width="5%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.getNotificationsList != undefined && this.state.getNotificationsList.length > 0 ? this.state.getNotificationsList.map((notifications, index) => {
                                                        let d = new Date(notifications.expiry);
                                                        let expiryDate = d.toLocaleDateString();
                                                        return (
                                                            <tr key={index}>
                                                                <td scope="row">{index + 1}</td>
                                                                <td>{notifications.title}</td>
                                                                <td>{notifications.notification_message}</td>
                                                                <td>{notifications.notification_for}</td>
                                                                <td className="tdTextCenter">
                                                                    <a className="actionIcon" title="Push" href="javascript:void(0)" onClick={() => this.pushNotifications(notifications.title, notifications.notification_message, index)}><span><img src="assets/img/svg/motification-icon.svg" alt="Push"/></span></a>
                                                                </td>
                                                                <td className="tdTextCenter">
                                                                    <a className="actionIcon" title="Delete" href="javascript:void(0)" onClick={() => this.DeletePopupOpen(notifications._id, 'deleteOpen', 'deleteClick')}><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span></a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }) : <tr>
                                                            <td colSpan="6" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>

                {/* Start Popup -Edit notifications details  */}
                <AddPushNotifications
                    popupType={this.state.popupType}
                    userData={this.state.data}
                    currentPage={this.state.currentPage}
                    addButton={this.state.addButton}
                    editOpen={this.state.editOpen}
                    funPopupClose={this.popupClose}
                    funNotificationsAddUpdate={(e, data) => this.notificationsAddUpdate(e, data)}
                    defaultData={this.state.notifications}
                />
                {/* End Popup -Edit notifications details  */}
                {/* Delete popup */}
                <DeletePopup deleteOpen={this.state.deleteOpen} deleteId={this.state.deleteId} funPopupClose={this.popupClose} funDelete={this.deleteNotifications} />
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getNotificationsList, language } = state;
    return {
        getNotificationsList,
        language
    };
}

const connectedPushNotifications = connect(mapStateToProps)(PushNotifications);
export { connectedPushNotifications as PushNotifications };
